import {
  DashboardOutlined,
  SettingOutlined,
  TeamOutlined,
  CalendarOutlined,
  BookOutlined,
  DollarOutlined,
  IdcardOutlined,
  ShoppingOutlined,
  ContactsOutlined,
  BankOutlined,
  BarChartOutlined,
  UserOutlined,
  AuditOutlined,
  MessageOutlined,
} from '@ant-design/icons';
import type { ComponentType } from 'react';
import type { Actions, Subjects } from '@/auth/ability';

export interface NavItem {
  key: string;
  path: string;
  label: string;
  icon: ComponentType;
  group?: string;
  /**
   * Ability gate for this nav entry. Hidden when `ability.can(action, subject)`
   * is false. Omit to show the link for anyone authenticated (e.g. dashboard).
   */
  can?: { action: Actions; subject: Subjects };
}

export const navItems: NavItem[] = [
  { key: 'dashboard', path: '/dashboard', label: 'Dashboard', icon: DashboardOutlined },

  { key: 'students',   path: '/students',   label: 'Students',   icon: TeamOutlined,     group: 'Academics', can: { action: 'view', subject: 'Student'    } },
  { key: 'attendance', path: '/attendance', label: 'Attendance', icon: CalendarOutlined, group: 'Academics', can: { action: 'view', subject: 'Attendance' } },
  { key: 'academics',  path: '/academics',  label: 'Academics',  icon: BookOutlined,     group: 'Academics', can: { action: 'view', subject: 'Academics'  } },

  { key: 'fee',     path: '/fee',     label: 'Fee Management',    icon: DollarOutlined, group: 'Finance', can: { action: 'view', subject: 'Fee'     } },
  { key: 'finance', path: '/finance', label: 'Accounts & Ledger', icon: BankOutlined,   group: 'Finance', can: { action: 'view', subject: 'Finance' } },

  { key: 'hr',            path: '/hr',            label: 'Staff & HR',    icon: IdcardOutlined,   group: 'Operations', can: { action: 'view', subject: 'Staff'        } },
  { key: 'inventory',     path: '/inventory',     label: 'Inventory',     icon: ShoppingOutlined, group: 'Operations', can: { action: 'view', subject: 'Inventory'    } },
  { key: 'frontdesk',     path: '/frontdesk',     label: 'Front Desk',    icon: ContactsOutlined, group: 'Operations', can: { action: 'view', subject: 'FrontDesk'    } },
  { key: 'notifications', path: '/notifications', label: 'Notifications', icon: MessageOutlined,  group: 'Operations', can: { action: 'view', subject: 'Notification' } },

  { key: 'reports', path: '/reports', label: 'Reports', icon: BarChartOutlined, group: 'Insights', can: { action: 'view', subject: 'Report' } },

  { key: 'setup',         path: '/setup',              label: 'Setup',           icon: SettingOutlined, group: 'Administration', can: { action: 'view', subject: 'Setup'    } },
  { key: 'users',         path: '/users',              label: 'User Management', icon: UserOutlined,    group: 'Administration', can: { action: 'view', subject: 'User'     } },
  { key: 'audit',         path: '/audit/auth-events',  label: 'Audit Log',       icon: AuditOutlined,   group: 'Administration', can: { action: 'view', subject: 'AuditLog' } },
  { key: 'audit-history', path: '/audit/history',      label: 'Record History',  icon: AuditOutlined,   group: 'Administration', can: { action: 'view', subject: 'AuditLog' } },
];

export const navGroups: Array<{ group: string | null; items: NavItem[] }> = (() => {
  const groups = new Map<string | null, NavItem[]>();
  for (const item of navItems) {
    const g = item.group ?? null;
    if (!groups.has(g)) groups.set(g, []);
    groups.get(g)!.push(item);
  }
  return Array.from(groups, ([group, items]) => ({ group, items }));
})();
